import React from 'react';
import { DASHBOARD_URL } from '../config/const.js';

const CTA = () => {
  return (
    <section className="cta">
      <div className="cta-content">
        <h2 style={{ fontSize: '48px' }}>Let AI truly</h2>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '16px', alignItems: 'center', justifyContent: 'center', marginTop: '-24px' }}>
          <h2>memorize</h2>
          <h2 style={{ color: '#2596D1' }}>you</h2>
        </div>
        <p>Instant memory for LLMs—better, cheaper, personal.</p>
      </div>
      <div className="cta-buttons">
        <a href={DASHBOARD_URL} className="btn btn-primary btn-lg" target="_blank" rel="noopener noreferrer">
          Get started
        </a>
        <a href="/pricing" className="btn btn-outline btn-lg">Pricing</a>
      </div>
    </section>
  );
};

export default CTA;